/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import {
  getDexWallet,
  createDexWallet,
  itemsSearch,
  itemsBreed,
  agreePolicy,
} from "../../../services/app";
import { useNavigate } from "react-router-dom";
import { ITEM_TYPES, SORT_TYPE } from "../../../constants";
import { ItemEarnBig } from "../../../components/HomeGuide/ItemEarnBig";
import { ItemWeb3Kit } from "../../../components/HomeGuide/ItemWeb3Kit";
import { ItemReady } from "../../../components/HomeGuide/ItemReady";
import { ItemBoost } from "../../../components/HomeGuide/ItemBoost";
import { ItemEarner } from "../../../components/HomeGuide/ItemEarner";
import * as Notification from "../../../Notification";
import {ModalMintNotify} from "../../../components/ModalMintNotify";
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Scrollbar } from "swiper";
import 'swiper/swiper-bundle.css'
import { ItemGrab } from "../../../components/HomeGuide/ItemGrab";
import { ItemAffiliate } from "../../../components/HomeGuide/ItemAffiliate";
import { ModalPolicy } from "../../../components/AffiliateComponent/ModalPolicy";
import useAffiliate from "../../../hook/useAffiliate";
import { PREPOSITION } from "..";

const MAX_ITEM_HOME = 4;
export const HomeGuide = () => {
  const { T, user } = useApp();
  const navigate = useNavigate();
  const [isBtnLoading, $isBtnLoading] = useState(false);
  const [isShowCreateWeb3, setIsShowCreatWeb3] = useState(false);
  const [loadingContent, setLoadingContent] = useState(false);
  const [isShowCreateWeb3ToClaim, setIsShowCreateWeb3ToClaim] = useState(false);
  const [isShowCreateWeb3Success, setIsShowCreatWeb3Success] = useState(false);
  const paramsSearch = {
    itemTypes: [],
    page: 1,
    size: MAX_ITEM_HOME,
    sort: SORT_TYPE.CREATED_TIME,
  };
  const [itemsCategories, setItemsCategories] = useState([])
  const [dataGuild, setDataGuild] = useState({
    address: null,
    earners: [],
    minted: []
  })
  const {
    onAffiliate,
    onConfirmPolicy,
    isOpenModalPolicy,
    setIsOpenModalPolicy,
  } = useAffiliate(); 
  const loadData = async () => {
    setLoadingContent(true);
    const promises = [];
    promises.push(
      itemsSearch({ ...paramsSearch, itemTypes: [ITEM_TYPES.ITEM_TYPE_DOG] })
    );
    promises.push(
      itemsSearch({ ...paramsSearch, itemTypes: [ITEM_TYPES.ITEM_TYPE_DOG], isNFT: true })
    );
    promises.push(
      getDexWallet()
    );
    promises.push(itemsBreed(9));

    Promise.all(promises).then((result) => {
      const dataEarners = result[0].data?.data?.items?.rows || [];
      const dataMinted = result[1].data?.data?.items?.rows || [];
      const dataWallet = result[2]?.data?.data?.public_address || null;
      const dataCategories = result[3]?.data?.data?.categories || [];
      setDataGuild({
        minted: dataMinted,
        address: dataWallet,
        earners: dataEarners,
      })
      setItemsCategories(dataCategories);
    
    }).finally(() => {
      setLoadingContent(false);
    });
  };

  const linkBuyEarner = user?.store_shopify;
  
  const handleExploreEarner = () => {
    navigate(`/asset?type=${PREPOSITION.EARNER}`);
  }

  const boostSOTLink = '/wallet?type=option';

  const claimSot = async () => {
    try {
      const resultDexWallet = await getDexWallet();
      if(resultDexWallet && resultDexWallet.data && resultDexWallet.data.data && resultDexWallet.data.data.public_address) {
        navigate(
          `/wallet?type=option`
        );
      }else{
        setIsShowCreateWeb3ToClaim(true)
      }
    }catch(e){
      setIsShowCreateWeb3ToClaim(true)
    }
  }
  useEffect(() => {
    loadData();
  }, []);

  const hanldeCreateWeb3Address = async (type) => {
    try {
      if (isBtnLoading) return
      $isBtnLoading(true)
      const createResult = await createDexWallet();
      if (createResult?.data?.error?.status) {
        loadData()
        if (type === 1) {
          setIsShowCreatWeb3(true)
        }else{
          setIsShowCreatWeb3Success(true)
          setIsShowCreateWeb3ToClaim(false)
        }
        
      } else {
        Notification.error(T(createResult?.data?.error?.message));
      }
    } catch (e) {
      Notification.error(T("Create web3 wallet unsuccessfully"));
    }
    $isBtnLoading(false)
  };
  return (
    // <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px] lg:gap-[30px] mt-[30px] lg:mt-[50px]">
    loadingContent ? <></>: <div className="mt-[20px] lg:mt-[30px] relative">
        <Swiper
          slidesPerView={1}
          centeredSlides={false}
          breakpoints={{
            769: {
              slidesPerView: 2,
              spaceBetween:30,
            },
          }}
          grabCursor={true}
          scrollbar={{ draggable: true }}
          spaceBetween={20}
          navigation={{ nextEl: ".arrow-right", prevEl: ".arrow-left" }}
          modules={[Navigation, Scrollbar]}
          className="mySwiper"
        >
          {user.evf_affid && (
            <SwiperSlide>
              <div className="w-full overflow-hidden">
                <ItemAffiliate
                    title={T('Extreme profitable community')}
                    description={T('Explore our alluring business model and commission structure, revealing remarkable opportunitie')}
                    className='affiliate-bg'
                    btnActionTitle={T('My Affiliate')}
                    btnAction={onAffiliate}
                />
              </div>
            </SwiperSlide>
          )}
          {!user.evf_affid && (
            <SwiperSlide>
              <div className="w-full overflow-hidden">
                <ItemAffiliate
                    title={T('Extreme profitable community')} 
                    description={T('Join the network, invite your friend and enjoy benefit together.')}
                    className='affiliate-bg'
                    btnActionTitle={T('Join now')}
                    btnAction={onAffiliate}
                />
              </div>
            </SwiperSlide>
          )}
          {(!dataGuild?.address && dataGuild?.earners?.length == 0) && <>
            <SwiperSlide><div className="w-full overflow-hidden">
                <ItemEarnBig 
                    title={'item_earner_big_title'} 
                    description={'Buy a Art, enjoy attached SOTs, and turn your earner into NFTs to trade on global marketplaces.'}
                    className='earn-big-bg'
                    btnLink={linkBuyEarner}
                />
            </div></SwiperSlide>
            <SwiperSlide><div className="w-full overflow-hidden">
                <ItemWeb3Kit 
                    title={'item_web3_title'} 
                    description={'Unlock seamless trading, storing, and managing with AI Avatar Web3 Wallet. Secure your crypto and NFTs with 24/7 access.'}
                    className='web-3-bg'
                    handleAction={() => hanldeCreateWeb3Address(1)}
                    isLoading={isBtnLoading}
                />
            </div></SwiperSlide>
            
            
          </>}
          {(!dataGuild?.address && dataGuild?.earners?.length > 0 && dataGuild?.minted?.length === 0) && <>
            <SwiperSlide><div className="w-full overflow-hidden">
              <ItemReady 
                  title={'item_ready_title'} 
                  description={'Ensure you have an active AI Avatar Web3 account. Your minted NFT will be securely stored in our Web3 Wallet and can be easily traded on any NFT marketplace.'}
                  className='ready-turner-bg'
                  isShowBtn={true}
                  actionBtn={handleExploreEarner}
                  actionBtnRight={() => hanldeCreateWeb3Address(1)}
                  isLoading={isBtnLoading}
              />
            </div></SwiperSlide>
            <SwiperSlide><div className="w-full overflow-hidden">
              <ItemEarner
                  title={'Your recent purchased Avatar'}
                  itemData={dataGuild?.earners?.[0]}
                  categories={itemsCategories}
                  type={1}
              />
            </div></SwiperSlide>
            <SwiperSlide><div className="w-full overflow-hidden">
              <ItemGrab
                  title={'grab_item_title'} 
                  description={'Your Moment is Now: Redeem SOT1*, Swap to SGT on Polygon, and Boost Your Wealth!'}
                  description2={'*Only applicable for users own SOT1 points'}
                  className='grab-bg'
                  btnAction={claimSot}
              />
            </div></SwiperSlide>
          </>}
          {(dataGuild?.address && dataGuild?.earners?.length === 0) && <>
            <SwiperSlide><div className="w-full overflow-hidden">
                <ItemEarnBig 
                    title={'item_earner_big_title'} 
                    description={'Buy a Art, enjoy attached SOTs, and turn your earner into NFTs to trade on global marketplaces.'}
                    className='earn-big-bg'
                    btnLink={linkBuyEarner}
                />
            </div></SwiperSlide>
            <SwiperSlide><div className="w-full overflow-hidden">
                <ItemReady 
                  title={'item_ready_title'} 
                  description={'Ensure you have an active AI Avatar Web3 account. Your minted NFT will be securely stored in our Web3 Wallet and can be easily traded on any NFT marketplace.'}
                  className='ready-turner-bg'
                  isShowBtn={false}
                  actionBtn={handleExploreEarner}
                />
            </div></SwiperSlide>
            <SwiperSlide><div className="w-full overflow-hidden">
              <ItemGrab
                  title={'grab_item_title'} 
                  description={'Your Moment is Now: Redeem SOT1*, Swap to SGT on Polygon, and Boost Your Wealth!'}
                  description2={'*Only applicable for users own SOT1 points'}
                  className='grab-bg'
                  btnAction={claimSot}
              />
            </div></SwiperSlide>
          </>}
          {(dataGuild?.address && dataGuild?.earners?.length > 0 && dataGuild?.minted?.length === 0) && <>
            <SwiperSlide><div className="w-full overflow-hidden">
              <ItemReady 
                  title={'item_ready_title'} 
                  description={'Ensure you have an active AI Avatar Web3 account. Your minted NFT will be securely stored in our Web3 Wallet and can be easily traded on any NFT marketplace.'}
                  className='ready-turner-bg'
                  isShowBtn={false}
                  actionBtn={handleExploreEarner}
              />
            </div></SwiperSlide>
            <SwiperSlide><div className="w-full overflow-hidden">
              <ItemEarner
                  title={'Your recent purchased Avatar'}
                  itemData={dataGuild?.earners?.[0]}
                  categories={itemsCategories}
                  type={1}
              />
            </div></SwiperSlide>
            <SwiperSlide><div className="w-full overflow-hidden">
              <ItemGrab
                  title={'grab_item_title'} 
                  description={'Your Moment is Now: Redeem SOT1*, Swap to SGT on Polygon, and Boost Your Wealth!'}
                  description2={'*Only applicable for users own SOT1 points'}
                  className='grab-bg'
                  btnAction={claimSot}
              />
            </div></SwiperSlide>
          </>}
          {(dataGuild?.address && dataGuild?.earners?.length > 0 && dataGuild?.minted?.length > 0) && <>
            <SwiperSlide><div className="w-full overflow-hidden">
              <ItemBoost
                  title={'item_boost_title'} 
                  description={'The more SOTs you add to your AI Avatar NFTs, the more opportunities you have to increase your income.'}
                  className='boost-bg'
                  onClick={() => navigate(boostSOTLink)}
              />
            </div></SwiperSlide>
            <SwiperSlide><div className="w-full overflow-hidden">
              <div className="w-full overflow-hidden">
                <ItemEarner
                    title={'Your recent minted NFT'}
                    itemData={dataGuild?.minted?.[0]}
                    categories={itemsCategories}
                    type={2}
                />
              </div>
            </div></SwiperSlide>
            <SwiperSlide><div className="w-full overflow-hidden">
              <ItemGrab
                  title={'grab_item_title'} 
                  description={'Your Moment is Now: Redeem SOT1*, Swap to SGT on Polygon, and Boost Your Wealth!'}
                  description2={'*Only applicable for users own SOT1 points'}
                  className='grab-bg'
                  btnAction={claimSot}
              />
            </div></SwiperSlide>
          </>}
          
        </Swiper>
        <button className="arrow-left swiper-button-prev"></button>
        <button className="arrow-right swiper-button-next"></button>
        {isShowCreateWeb3 && (
          <ModalMintNotify
            onClose={() => setIsShowCreatWeb3(false)}
            onSubmit={() => setIsShowCreatWeb3(false)}
            isLoading={isBtnLoading}
            title={T("Created Web3 Wallet successfully")}
            des={"Your web3 wallet has been created successfully. Please access your Web3 Wallet on AI Avatar app. Now you can trade, store and manage your crypto and NFTs with AI Avatar Web3 Wallet."}
            buttonText={T("OK")}
          />
        )}
        {isShowCreateWeb3ToClaim && (
        <ModalMintNotify
            onClose={() => setIsShowCreateWeb3ToClaim(false)}
            onSubmit={() => hanldeCreateWeb3Address(2)}
            isLoading={isBtnLoading}
            title={T("AI Avatar Web3 Wallet not created!")}
            des={T(
              "You have not created AI Avatar Web3 Wallet to grab SOT1. Please create a AI Avatar Wallet and try again!"
            )}
            buttonText={T("Create Web3 Wallet")}
          />
        )}
        {isShowCreateWeb3Success && (
          <ModalMintNotify
            onClose={() => setIsShowCreatWeb3Success(false)}
            onSubmit={() => claimSot()}
            title={T("Created Web3 Wallet successfully!")}
            des={T(
              "Your web3 wallet has been created successfully. Please access your web3 wallet on AI Avatar app. Now you can convert SOT to SGT using AI Avatar Web3 wallet."
            )}
            buttonText={T("Continue to claim")}
          />
        )}

        {isOpenModalPolicy && (
          <ModalPolicy
            onClose={() => setIsOpenModalPolicy(false)}
            handleSubmit={() => onConfirmPolicy()}
          ></ModalPolicy>
        )}

  </div>
  );
};
